import moment from 'moment';

export default function userReadable(date) {
    return moment(date).format('LLL');
}



// WEBPACK FOOTER //
// ./src/utils/time.js